import eventBus from '../../js/event-bus/event-bus';
import getPosition from '../../js/get-position/get-position';
import tabbable from 'tabbable';
import lang from './modal-lang.json';
const NUMBER_OF_TABBING_HELPERS = 2;
export default {
	data() {
		return {
			stickyTop: null,
			visible: false,
			modalType: null,
			allTabbableElements: [],
			returnFocusToElement: null,
			parentModuleText: null,
			payload: null,
			callRequestInitialized: false,
			headerTextId: null,
			elementsWithoutAriaHidden: null
		};
	},
	locales: lang,
	props: {
		modalId: {
			required: true
		},
		type: {
			required: false
		},
		callRequestApi: {
			required: false
		},
		gaCategory: {
			required: false
		},
		gaAction: {
			required: false
		},
		open: {
			required: false,
			default: false
		},
		closable: {
			required: false,
			default: true
		},
		closeBtnVisible: {
			required: false,
			default: true
		},
		closePopupText: {
			required: false
		},
		ariaDescribedby: {
			required: false
		}
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	methods: {
		touchScrollEventHandler(event) {
			event.preventDefault();
		},
		jumpToFirstTabbable() {
			if (this.$listeners && this.$listeners['on-jump-to-first-tabbable']) {
				this.$emit('on-jump-to-first-tabbable');
			} else {
				this.$refs.firstTabbable.focus();
			}
		},
		jumpToLastTabbable() {
			this.allTabbableElements = tabbable(this.$el);
			this.allTabbableElements[this.allTabbableElements.length - NUMBER_OF_TABBING_HELPERS].focus();
		},
		getAllSiblings(element, parent) {
			const children = [...parent.children];
			return children.filter((child) => child !== element && child.getAttribute('aria-hidden'));
		},
		closePopup() {
			this.$gtm.trackEvent({
				event: 'modalClosed'
			});
			this.visible = false;
			eventBus.$emit('toggleAriaHidden', this.visible);
			eventBus.$emit('modal-closed', this.modalId);
			this.$refs.dialog.removeEventListener('scroll', this.onScroll);
			let modalContent = document.getElementById('modal-content');
			if (modalContent) {
				let allSiblings = this.getAllSiblings(modalContent, modalContent.parentNode);
				this.elementsWithoutAriaHidden = this.getAllSiblings(modalContent, modalContent.parentNode);
				[...allSiblings].forEach((item) => {
					item.setAttribute('aria-hidden', 'false');
				});
			}
			document.body.classList.remove('modal-open');
			if (this.callRequestApi && window[this.callRequestApi]) {
				window[this.callRequestApi].resetForm({ modalId: this.modalId });
			}
			this.$nextTick(() => {
				this.returnFocusToElement && this.returnFocusToElement.focus();
			});
		},
		openPopup() {
			this.visible = true;
			eventBus.$emit('toggleAriaHidden', this.visible);
			eventBus.$emit('modal-opened', this.modalId, this.payload);
			document.body.classList.add('modal-open');
			let modalContent = document.getElementById('modal-content');
			if (modalContent && this.elementsWithoutAriaHidden) {
				this.elementsWithoutAriaHidden.forEach((item) => {
					item.setAttribute('aria-hidden', 'true');
				});
			}
			this.$nextTick(() => {
				if (this.$refs.dialog) {
					this.$refs.dialog.addEventListener('scroll', this.onScroll);
				}
			});
			if (this.callRequestApi && window[this.callRequestApi] && !this.callRequestInitialized) {
				this.callRequestInitialized = true;
				window[this.callRequestApi].initForm({ modalId: this.modalId });
			}
			setTimeout(() => {
				this.allTabbableElements = tabbable(this.$el);
			});
		},
		onScroll() {
			if (this.$refs.dialog) {
				let scrollTop = getPosition(this.$refs.dialog).y;
				this.stickyTop = scrollTop < 0;
			}
		},
		keyHandler(e) {
			if (this.visible) {
				if (e.which == 27) {
					this.closable && this.closePopup();
				}
			}
		}
	},
	watch: {
		visible(val) {
			eventBus.$emit('toggleAriaHidden', val);
			if (val) {
				this.$nextTick(() => {
					if (this.$refs.firstTabbable) {
						this.$refs.firstTabbable.focus();
					}
				});
			}
		},
		stickyTop() {
			if (this.$refs.firstTabbable == document.activeElement) {
				this.$nextTick(() => {
					this.$refs.firstTabbable.focus();
				});
			}
		},
		isMobile() {
			this.allTabbableElements = tabbable(this.$el);
		}
	},
	mounted() {
		const parentContainer = document.querySelector('.modal-frame');
		const headerElement = parentContainer.querySelector('h1, h2, h3, h4, h5, h6');
		if (headerElement) {
			this.headerTextId = headerElement.id;
		}
		window.addEventListener('keyup', this.keyHandler);
		eventBus.$on('openModal', (e, modalId, options) => {
			if (modalId == this.modalId) {
				if (options && options.payload) {
					this.payload = options.payload;
				}
				this.returnFocusToElement = e.target;
				this.openPopup();
				if (options && options.scrollId) {
					this.$nextTick(() => {
						let elem = document.getElementById(options.scrollId);
						if (elem) {
							this.$scrollTo(elem, { duration: 500, container: '.modal', offset: options.offset || 0 });
						}
					});
				}
				// GA kuldeshez kell tudni melyik moduleban vagyunk
				if (options && options.parentModuleText) {
					this.parentModuleText = options.parentModuleText;
				}
			}
		});
		eventBus.$on('closeModal', (modalId) => {
			if (modalId == this.modalId) {
				if (this.visible) {
					this.closePopup();
				}
			}
		});
		eventBus.$on('changeModalType', ({ modalType, modalId }) => {
			if (modalId == this.modalId) {
				this.modalType = modalType;
			}
		});
	},
	beforeDestroy() {
		window.removeEventListener('keyup', this.keyHandler);
	},
	created() {
		this.modalType = this.type;
		this.open && this.openPopup();
	}
};
